import type { Handler } from './handler';
import type { ApiPostDailyCheckinClaimPort } from './ports/api-post-daily-checkin-claim.port';
import { USE_MOCK, claimOnMockBoard } from './daily-checkin.mock';
import type { DailyCheckinClaimResult } from '~/types/daily-checkin';
import { resolveAdapter } from '~/adapters/registry';
import { DailyCheckinClaimError } from '~/adapters/api-daily-checkin/daily-checkin-api';

// POST /daily-check-in/claim. Não recebe qual degrau resgatar: quem decide é o
// servidor (ou o mock, que imita a mesma regra).
export const postDailyCheckinClaimHandler: Handler<
  Params,
  Ports,
  Result
> = async (
  params,
  ports = {
    apiPostDailyCheckinClaim: resolveAdapter('apiPostDailyCheckinClaim'),
  },
) => {
  if (USE_MOCK) {
    const reward = claimOnMockBoard();

    // Mesma recusa que o core daria com a trilha no fim, pra o caminho de erro
    // também ser exercitável sem rede.
    if (!reward) throw new DailyCheckinClaimError('track_completed');

    return reward;
  }

  return await ports.apiPostDailyCheckinClaim.handle({ userId: params.userId });
};

type Params = { userId: number };

type Ports = { apiPostDailyCheckinClaim: ApiPostDailyCheckinClaimPort };

type Result = Promise<DailyCheckinClaimResult>;
